<div class="alert" [ngClass]="type" role="alert">
    {{msg}}
</div>
  